__turbopack_context__.v({
  "ThreeColumnModule": "BzZk4W_ThreeColumnModule",
  "ThreeColumnModule__Column": "BzZk4W_ThreeColumnModule__Column",
  "ThreeColumnModule__Container": "BzZk4W_ThreeColumnModule__Container",
  "ThreeColumnModule__Grid": "BzZk4W_ThreeColumnModule__Grid",
  "ThreeColumnModule__List": "BzZk4W_ThreeColumnModule__List",
  "ThreeColumnModule__ListItem": "BzZk4W_ThreeColumnModule__ListItem",
  "ThreeColumnModule__Preamble": "BzZk4W_ThreeColumnModule__Preamble",
  "ThreeColumnModule__Title": "BzZk4W_ThreeColumnModule__Title",
});
